import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var Svg18DoublearrowG3 = /*#__PURE__*/React.memo(function (props) {
  var theme = useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.themeMode.lightPalette.colorSet.white1000,
      fillRule: "evenodd",
      opacity: 0.32,
      children: [/*#__PURE__*/jsx("path", {
        d: "M12.03 8.46a.65.65 0 0 0 .989-.839l-.069-.08-3.992-4a.65.65 0 0 0-.839-.07l-.08.069-4.008 4a.65.65 0 0 0 .838.989l.08-.069 3.547-3.54z"
      }), /*#__PURE__*/jsx("path", {
        d: "M12.03 13.46a.65.65 0 0 0 .989-.839l-.069-.08-3.992-4a.65.65 0 0 0-.839-.07l-.08.069-4.008 4a.65.65 0 0 0 .838.989l.08-.069 3.547-3.54z"
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18DoublearrowG3$1 = Svg18DoublearrowG3;

export { Svg18DoublearrowG3$1 as default };
